/** 接口请求地址 */
// export const BASE_URL = 'http://192.168.1.76:8080' // cjz公司
export const BASE_URL = 'https://api.hxtmy.cn'  // 服务器
// export const BASE_URL = 'https://29d630b9.r15.vip.cpolar.cn'    // 内网穿透

/**
 * 是否开启代理
 * - 开发环境：nodejs把/api代理到{BASE_URL}/api
 * - 生产环境：nginx自定义配置
 */
export const PROXY_OPEN = false
